import { render, staticRenderFns } from "./PageSetGood.vue?vue&type=template&id=74ed76a0&scoped=true&"
import script from "./PageSetGood.vue?vue&type=script&lang=js&"
export * from "./PageSetGood.vue?vue&type=script&lang=js&"
import style0 from "./PageSetGood.vue?vue&type=style&index=0&id=74ed76a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed76a0",
  null
  
)

export default component.exports